<template lang="pug">
  div()
    section.grey.lighten-3()
      v-tabs(fixed-tabs dark background-color='primary', slider-color='white' color='white')
        v-tab
          .white--text.font-weight-bold() Vehicles
        v-tab-item

          vehicle-auto-complete.grey.lighten-3.px-4.pt-2(v-model='vehicleID' :key="vehicleKey" label="Select Vehicle*" placeholder="Vehicle to View" :items="this.items")
      
          .dateButtonContainer.grey.lighten-3()
            button.dateButton2.primary.subtitle-2.white--text(type="input" v-html="getDateRange" @click="onOpenDialog") 


          .SideBarFilter.grey.lighten-3.pa-4.d-flex
            a(:href="getPDFDownloadURL" :download="getPDFFileName" style="text-decoration:none")
              v-btn(outlined small color="primary" )
                | Download
                v-icon.ml-2(:size="18") print
            //- a.mx-4(:href="getAllPDFDownloadURL" :download="getAllPDFFileName" style="text-decoration:none")
            v-btn.mx-4(outlined small color="primary" @click="downloadPDFAll" )
              | All
              v-icon.ml-2(:size="18") email

            v-spacer()
            //- v-menu(bottom left)
              template(#activator="{ on }")
                v-btn(outlined small v-on="on", color='primary')
                  span {{ sortBy }}
                  v-icon.tripFilter(large) arrow_drop_down

            v-icon filter_list
            
          //-  Moving Vehicles
          trip-movement-container()
          
          
        v-tab
          .white--text.font-weight-bold() Drivers
        v-tab-item
        
          v-text-field.grey.lighten-3.pa-4(append-icon='search', hide-details label='Search Driver', text)
          .SideBarFilter.grey.lighten-3.pa-4
            v-menu(bottom left)
              template(#activator="{ on }")
                v-btn(outlined small v-on="on", color='primary')
                  span {{ sortBy }}
                  v-icon.tripFilter(large) arrow_drop_down
          
            v-icon filter_list

    v-dialog(v-model="showDialog" width="500" height="500" persistent )
      v-card()
     
        .d-flex.justify-space-between.primary.pa-2()
          .d-flex.flex-column.white--text
            .title(v-html="getDateRangeLong")
  

        v-divider()
        vue-ctk-date-time-picker(
          v-model="thedate" 
          inline 
          :no-header="true"
          :right="false" 
          :range="true" 
          :button-color="$vuetify.theme.themes.light.primary" 
          :color="$vuetify.theme.themes.light.primary"
          :custom-shortcuts="shortcuts"
          )
        v-divider()
          
        v-layout(justify-end )
          v-btn.mx-2.my-4.grey--text(@click="onCancelDialog"  outlined small) Cancel
          v-btn.mx-2.my-4(@click="onUpdateDate" color="primary" small) Update
          
    v-dialog(v-model="exportTripDialog" width="500" persistent )
      export-trip-history-dialog(v-if="exportTripDialog" @closeTripDialog="onCloseTripDialog")

  </template>

<script>
import TripSidebarDivider from "@/modules/maps/components/ui/SideBar/TripSidebarDivider";
import TripMovementContainer from "@/modules/maps/components/ui/SideBar/TripMovementContainer";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import VehicleAutoComplete from "@/modules/global/components/forms/VehicleAutoComplete";
import ExportTripHistoryDialog from "@/modules/maps/components/ui/Dialog/ExportTripHistoryDialog";
import moment from "moment";

export default {
  props:["vehicle_id","items"],
  components: {
    TripSidebarDivider,
    TripMovementContainer,
    VueCtkDateTimePicker,
    VehicleAutoComplete,
    ExportTripHistoryDialog
  },

  data: () => ({
    vehicleKey: 1,
    sortBy: "",
    thedate: { start: "2020-01-23 12:00 am", end: "2020-01-27" },

    shortcuts: [
      { key: "today", label: "Today", value: 0 },
      { key: "yesterday", label: "Yesterday", value: "-day" },
      { key: "last7Days", label: "Last 7 days", value: 7 },
      { key: "last14Days", label: "Last 14 days", value: 14 },
      { key: "last30Days", label: "Last 30 days", value: 30 }
    ],
    showDialog: false,
    exportTripDialog: false,
    initializedDate: false,
  }),



  mounted() {

    this.vehicleID = this.vehicle_id;
  },

  computed: {
    getPDFDownloadURL: function(){
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").toISOString();
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()
      }
      return `/api/trip/vehicleMovementReport?vehicle_id=${this.vehicleID}&from=${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()}&to=${endDate}`
    },
    getPDFFileName: function(){
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").format("YYYY-MM-DD");
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").format("YYYY-MM-DD")
      }
      return `Trip_${this.$store.getters["vehicles/getVehicleByID"](this.vehicleID).name}_${moment(this.thedate.start,  "YYYY-MM-DD h:mm a").format("YYYY-MM-DD")}_to_${endDate}.pdf`
    },
    getAllPDFDownloadURL: function(){
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").toISOString();
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()
      }
      return `/api/trip/vehicleMovementReportAll?from=${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()}&to=${endDate}`
    },
    getAllPDFFileName: function(){
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").format("YYYY-MM-DD");
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").format("YYYY-MM-DD")
      }
      return `Trip_${this.$store.getters["vehicles/getVehicleByID"](this.vehicleID).name}_${moment(this.thedate.start,  "YYYY-MM-DD h:mm a").format("YYYY-MM-DD")}_to_${endDate}.pdf`
    },
    originalDate: {
      get: function() {
        return this.$store.getters["trips/getDateRange"];
      },
      set: function(value) {
        this.$store.commit("trips/setDateRange", value);
        this.$store.commit("timeline/setDateTimelineRange",value)
      }
    },

    vehicleID: {
      get: function() {
        return this.$store.state.trips.currentVehicleID;
      },
      set: function(value) {
        if(value != null){
          this.$store.commit("trips/setCurrentVehicleID",value)
          this.$store.commit("timeline/setCurrentVehicleID",value)
          this.$store.commit("vehicles/devices/setCurrentIndexByVehicleID",value)
          localStorage.setItem("mapSelectedVehicleId", value);
        }
        if(this.initializedDate === false){
           this.resetDateRangeToVehicle()
        }
        this.onRefreshServer();
      }
    },
    getDateRange: function() {

      let startDate = moment(
        this.originalDate.start,
        "YYYY-MM-DD h:mm a"
      ).format("ddd, Do MMM YY");



      // check if start and end date are the same
      let endDate = null;

      if (this.originalDate.end != null) {
        endDate = moment(this.originalDate.end, "YYYY-MM-DD h:mm a").format(
          "ddd, Do MMM YY"
        );
      }
      if (endDate == null) {
        return startDate;
      }

      if (startDate.toString() == endDate.toString()) {
        return startDate;
      } else {
        return startDate + "&nbsp;&nbsp; &mdash; &nbsp;&nbsp;" + endDate;
      }
    },

    getDateRangeLong: function() {
      // console.log(this.thedate.start);
      // console.log(this.thedate.end);
      let startDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").format(
        "DD MMMM YYYY"
      );

      // check if start and end date are the same
      let endDate = null;

      if (this.thedate.end != null) {
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").format(
          "DD MMMM YYYY"
        );
      }

      if (endDate == null) {
        return startDate + " &ndash; click end date";
      }

      if (startDate.toString() == endDate.toString()) {
        return startDate;
      } else {
        return startDate + " &ndash; " + endDate;
      }
    }
  },

  methods: {
    onCloseTripDialog:function(){
      this.exportTripDialog = false;
    },
    resetDateRangeToVehicle:function() {
      if(this.vehicleID == null){
        return;
      }


      let mapDateString = localStorage.getItem("mapsDateRange")


      let dateRangeObject = {};
      if (mapDateString != null && mapDateString.length > 0) {

        let obj = JSON.parse(mapDateString);
        dateRangeObject.start = moment(obj.startISODate).format("YYYY-MM-DD h:mm a");
        if(obj.endISODate == null){
          dateRangeObject.end = null
        }else{
          dateRangeObject.end = moment(obj.endISODate).format("YYYY-MM-DD h:mm a");
        }


      }else {

        dateRangeObject.start = moment(this.$store.getters["vehicles/devices/getCurrentDevice"].last_online_date)
            .subtract(1, "day") // .subtract(1, "day")  show 1 day before also
            .startOf("day").format("YYYY-MM-DD h:mm a");

        dateRangeObject.end = moment(this.$store.getters["vehicles/devices/getCurrentDevice"].last_online_date)
            .endOf("day")
            .format("YYYY-MM-DD h:mm a");
        // set the date and time for the trips object

      }

      this.$store.commit("trips/setDateRange", dateRangeObject);
      this.$store.commit("timeline/setDateTimelineRange", dateRangeObject);
      this.thedate = dateRangeObject;
      this.initializedDate = true;

    },

    onUpdateDate: function() {

      this.showDialog = false;

      this.onRefreshServer();
    },

    downloadPDF: function(){
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").toISOString()
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()
      }
      window.open(`/api/trip/vehicleMovementReport?from=${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()}&to=${endDate}`,"_blank");
    },

    downloadPDFAll: function() {
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").toISOString()
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()
      }
      this.exportTripDialog = true;
      //-- window.open(`/api/trip/vehicleMovementReportAll?from=${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()}&to=${endDate}`,"_blank");
    },
    onRefreshServer: function() {

      console.log(`start:${this.thedate.start} end:${this.thedate.end} currentVehicle:${this.$store.state.trips.currentVehicleID}`);
      if (this.$store.state.trips.currentVehicleID == null) {
        return;
      }

      this.$store.commit("trips/setDateRange",{start:this.thedate.start!=null?this.thedate.start.toString():null,end:this.thedate.end != null?this.thedate.end.toString():null})
      this.$store.commit("timeline/setDateTimelineRange",{start:this.thedate.start!=null?this.thedate.start.toString():null,end:this.thedate.end != null?this.thedate.end.toString():null})
0
      this.$store.dispatch("trips/loadTrips").then(() => {
        // // update the time
        this.originalDate = JSON.parse(JSON.stringify(this.thedate));
        if (this.$store.state.trips.trip_data.length > 0) {
          // set the trip to index 0 and load the path
          this.$store.commit("trips/setCurrentIndex", 0);
          // reload
          this.$store.dispatch("trips/loadPath");
        }
      });
    },

    onOpenDialog: function() {
      this.thedate = JSON.parse(JSON.stringify(this.originalDate));
      this.showDialog = true;
    },

    onCancelDialog: function() {
      this.showDialog = false;

      console.log(this.originalDate);
      console.log(this.thedate);
      this.thedate = JSON.parse(JSON.stringify(this.originalDate));
    },

    onSortBy: function(label) {
      switch (label) {
        case "NAME":
          // todo: call the sortByName getter function
          break;
        case "DISTANCE":
          // todo: call the sortByDistance getter function
          break;

        default:
          // todo: call the sortByName getter function
          break;
      }
      this.sortBy = label;
    },
     onPrint: function(){
        console.log(`Print the Dodcument ${this.vehicleID} ${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()} - ${moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()}`)
      
      }
  },

 

};
</script>

<style scoped>
.SideBarFilter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0px 17px 0px 8px;
}

.tripFilter {
  margin-left: 0px;
  margin-right: -15px;
}

.tripBold {
  font-weight: bolder;
}

.dateTimeHeader {
}

.dateButton2 {
  width: 90%;
  border-radius: 15px;
  padding: 5px 5px;
  max-width: 400px;
}

.dateButtonContainer {
  display: flex;
  justify-content: center;
}

.vehicleSearch {
  width: 90%;
  max-width: 400px;
  padding: 5px 5px;
}
</style>
